export default __webpack_public_path__ + "static/media/balance-auto-reminders-deadlne.40ca4076.md";